import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const SendIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0338 2.03524C12.5818 0.471534 1.65963 4.30209 1.66865 5.70062C1.67887 7.28656 5.93403 7.77442 7.11344 8.10536C7.82271 8.30429 8.01264 8.50829 8.17617 9.25203C8.91684 12.6203 9.28871 14.2956 10.1362 14.333C11.4872 14.3928 15.4508 3.56129 14.0338 2.03524Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M7.66864 8.33333L10.002 6"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SendIconMedium: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0477 3.05293C18.8697 0.707361 2.48648 6.4532 2.50001 8.551C2.51535 10.9299 8.89809 11.6617 10.6672 12.1581C11.7311 12.4565 12.016 12.7625 12.2613 13.8781C13.3723 18.9305 13.9301 21.4435 15.2014 21.4996C17.2278 21.5892 23.1733 5.342 21.0477 3.05293Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M11.5 12.5L15 9"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
